import { render } from "./PredictEstatesMap.vue?vue&type=template&id=8bb6635c&ts=true"
import script from "./PredictEstatesMap.vue?vue&type=script&lang=ts"
export * from "./PredictEstatesMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__